import BotDialogType from '../../core/type/dialog/BotDialogType';
import ButtonInputType from '../../core/type/input/ButtonInputType';
import UserDialogType from '../../core/type/dialog/UserDialogType';
import SelectorInputType from '../../core/type/input/SelectorInputType';
import Interceptor from '../../core/type/operation/Interceptor';
import { sendBotResponse } from './util';
import Switch from '../../core/type/operation/Switch';
import Case from '../../core/type/operation/Case';
import SeletorProjetoInputType from '../../core/type/input/SeletorProjetoInputType';
import TextInputType from '../../core/type/input/TextInputType';
import citiesJson from '../../util/geo/cities.json';
import states from '../../util/geo/states.json';

export default [
  new Interceptor(async (data) => new Promise((resolve) => {
    const cities = citiesJson.map((c) => {
      const state = states.find((s) => s.id === c.state_id);
      return (
        {
          id: c.id,
          value: c.name,
          text: `${c.name}-${state.abbr}`,
          state: state.abbr,
          state_full: state.name,
        }
      );
    });
    resolve({
      ...data,
      options: {
        ...data.options,
        cities,
      },
    });
  })),

  new BotDialogType({
    message: 'Qual dessas opções se encaixa melhor na sua situação:',
    checkpoint: true,
  }),

  new SelectorInputType({
    key: 'project_moment',
    type: 'radio',
    column: 'half',
    options: 'option_project_moment',
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    resolve({
      ...data,
      information: { ...data.information, project_moment: data.project_moment },
      project_moment: data.project_moment.text,
    });
  })),

  new UserDialogType({
    message: '#{project_moment}',
  }),

  new Switch({
    ref: 'information.project_moment',
    cases: [
      new Case({
        express: '\'$v\' === \'KNOW_WHAT_NEEDS\'',
        components: [
          new BotDialogType({
            message: 'Show! Neste caso, selecione abaixo o perfil de parceiro(s) que você procura',
            scroll: false,
          }),
          new SelectorInputType({
            key: 'services',
            type: 'checkbox',
            column: 'half',
            options: 'option_services',
            scroll: false,
          }),

          new Interceptor(async (data) => new Promise((resolve) => {
            const values = [...data.services];
            if (values.find((v) => v.value === 'none')) {
              resolve({
                ...data,
                information: { ...data.information, services: data.services },
                services: 'Não precisamos de nenhuma das alternativas indicadas.',
              });
            } else {
              const returnData = {
                ...data,
                information: { ...data.information, services: data.services },
                services: `Buscamos os seguintes perfis: ${data.services?.map((obj) => obj.text || obj.label).join(', ')}`,
              };
              if (values.find((v) => v.value === 'Outros')) {
                returnData.information.other_services = 'NEEDS_OTHER';
              }
              resolve(returnData);
            }
          })),

          new UserDialogType({
            message: '#{services}',
          }),

          new Switch({
            ref: 'information.other_services',
            cases: [
              new Case({
                express: '\'$v\' === \'NEEDS_OTHER\'',
                components: [
                  new BotDialogType({
                    message: 'Pode nos informar qual outro serviço que não estava listado?',
                    checkpoint: true,
                  }),

                  new TextInputType({
                    key: 'other_services',
                  }),

                  new UserDialogType({
                    message: '#{other_services}',
                  }),

                  new Interceptor(async (data) => new Promise((resolve) => {
                    resolve({
                      ...data,
                      information: { ...data.information, other_services: data.other_services },
                    });
                  })),

                ],
              }),
            ],
          }),
        ],
      }),
      new Case({
        express: '\'$v\' === \'NEED_HELP\'',
        components: [
          new BotDialogType({
            message: 'Ok, pode deixar que vamos te ajudar.',
            checkpoint: true,
          }),
        ],
      }),
    ],
  }),

  new BotDialogType({
    message: 'Agora, com base nas opções abaixo, nos informe qual sua expectativa com as soluções que apresentaremos para você.',
  }),

  new SeletorProjetoInputType({
    key: 'project_expectation',
  }),

  new Interceptor(async (data) => new Promise((resolve) => {
    const selectorMap = (selection) => {
      if (selection === 'quality') {
        return 'alta qualidade';
      } if (selection === 'time') {
        return 'resultado rápido';
      } if (selection === 'price') {
        return 'custo baixo';
      }
      return '';
    };
    const answer = data.project_expectation.map((s) => selectorMap(s)).join(' e ');
    resolve({
      ...data,
      information: { ...data.information, project_expectation: data.project_expectation },
      project_expectation: `Tenho a expectativa de soluções com ${answer}`,
    });
  })),

  new UserDialogType({
    message: '#{project_expectation}.',
  }),

  new BotDialogType({
    message: `Quanto mais detalhes você nos passar com relação as suas necessidades, mais assertivo será o nosso direcionamento. 
    O que acha de nos contar um pouco sobre os seus objetivos?`,
    checkpoint: true,
  }),

  new TextInputType({
    placeholder: 'Descreva sua necessidade.',
    key: 'description',
    textareaMode: true,
    optional: true,
  }),

  sendBotResponse(),
];
